import firebase from "firebase/compat/app";

const firestore = firebase.firestore();

const materialsPath = () => "materials";

export type ServerMaterial = {
  label: string;
};
export type Material = {
  id: string;
} & ServerMaterial;

export const fetchMaterials = async () => {
  const snap = await firestore.collection(materialsPath()).get();

  return snap.docs.map((val) => ({
    ...val.data(),
    id: val.id
  })) as Material[];
};

export async function addMaterial(material: ServerMaterial) {
  const res = await firestore.collection(materialsPath()).add(material);

  return { id: res.id, ...material } as Material;
}
